import { rei } from "@/services/api"

class MensalistaService {

    static storeMensalista (payload) {
        return rei.post('mensalista-store', payload)
          .then(res => res.data)
    }
    static validaCPF (cpf) {
        return rei.get(`mensalista/cpf/${cpf}`)
          .then(res => res.data)
    }
    static getMensalistas () {
        return rei.get(`mensalista/list`)
          .then(res => res.data)
    }
    static mudatStatus (id) {
        return rei.get(`mensalista/mudar-status/${id}`)
          .then(res => res.data)
    }

    static getPesquisa (text) {
      return rei.get(`mensalista/pesquisa/${text}`)
          .then(res => res.data)
    }

    static editarMensalista (mensalista) {
      return rei.post('mensalista/editar', mensalista)
        .then(res => res.data)
    }

    static buscarById (payload) {
      const searchParams = new URLSearchParams(payload)

      return rei.get(`mensalista/pedidos-filtro?${searchParams.toString()}`)
        .then(res => res.data)
    }

    static buscarByNome (nome, active) {
      if (active) {
        return rei.get(`mensalista-nome-ativo/${nome}`)
        .then(res => res.data)
      }
      return rei.get(`mensalista-nome/${nome}`)
        .then(res => res.data)
    }


    static buscarByCPF (cpf) {
      return rei.get(`mensalista-cpf/${cpf}`)
        .then(res => res.data)
    }

    static getPdfPedidosRealizados (mensalista) {
      return rei.post('mensalistas-pedidos-reslizados-pdf', mensalista, { responseType: 'arraybuffer' }).then((res) => {
        let blob = new Blob([res.data], { type: 'application/pdf' })
        let url = window.URL.createObjectURL(blob)
        return url
      })
    }

    static exportExcelRelatorio (payload) {
      return rei.post(`mensalistas-export-excel`, payload, {
        responseType: 'arraybuffer'
      }).then((res) => {
        return res
      })
    }
}

export default MensalistaService